import "./OverlayLoading.scss";

import * as React from "react";
import InlineLoading from "./InlineLoading";
import { LoadingOverlay, type LoaderProps } from "@mantine/core";

/**
 * Defines the inputs accepted by this layout component.
 */
interface IOverlayLoadingProps {
    size?: LoaderProps["size"];
    text?: string;
    onWhite?: boolean;
}

/**
 * Displays an always-visible loading overlay using the shared inline indicator.
 *
 * Postconditions: onWhite requests the existing dark overlay color; otherwise color is unspecified.
 * This component displays loading state and does not start or complete work.
 */
class OverlayLoading extends React.Component<IOverlayLoadingProps, any> {
    /**
     * Builds the loading presentation from the current props without managing task state.
     */
    render() {
        const { size = "lg", text, onWhite } = this.props;

        return (
            <LoadingOverlay
                visible={true}
                zIndex={1000}
                overlayProps={{
                    color: onWhite ? "dark" : undefined
                }}
                loaderProps={{
                    children: (
                        <InlineLoading
                            size={size}
                            text={text}
                        />
                    )
                }}
            />
        );
    }
}
export default OverlayLoading;
